import { formatToCommaWithLang, toCommaOptions } from '@slot-nx/core'
import { gsap } from 'gsap'
import { BitmapText, Text } from 'pixi.js'

export const numberAnimation = (
  startNum: number,
  endNum: number,
  duration: number,
  component: BitmapText | Text,
  { isPlayAudio = false, digits = 2 } = {},
): [Promise<void>, () => void] => {
  const displayNum = { value: startNum }
  let isSkip = false
  const anim = new Promise<void>((resolve) => {
    const task = gsap.to(displayNum, {
      value: endNum,
      duration: duration,
      onUpdate: () => {
        if (isSkip) {
          component.text = formatToCommaWithLang(endNum, navigator.language, toCommaOptions.forceTwoDecimalPlaces)
          // component.text = formatBalance(endNum, digits)
          resolve()
          task.kill()
          return
        }
        component.text = formatToCommaWithLang(
          displayNum.value,
          navigator.language,
          toCommaOptions.forceTwoDecimalPlaces,
        )
        // component.text = formatBalance(displayNum.value, digits)
      },
      onComplete: () => {
        resolve()
      },
    })
  })
  return [
    anim,
    () => {
      isSkip = true
    },
  ]
}
